// 测试主域名配置
// 用于复制链接、回调测试等场景中拼接测试 URL
export const ocpxDomain = 'ocpx.chaoliangzt.com'